/**
 * Order reject reason.
 */
export enum OrderRejectionReason {

    /** Broker Option */
    BROKER_OPTION       = 'BROKER_OPTION',

    /** Unknown Symbol */
    UNKNOWN_SYMBOL      = 'UNKNOWN_SYMBOL',

    /** Exchange Closed */
    EXCHANGE_CLOSED     = 'EXCHANGE_CLOSED',

    /** Exceeds Limit */
    EXCEEDS_LIMIT       = 'EXCEEDS_LIMIT',

    /** Too Late */
    TOO_LATE            = 'TOO_LATE',

    /** Unknown Order */
    UNKNOWN_ORDER       = 'UNKNOWN_ORDER',

    /** Duplicate Order */
    DUPLICATE_ORDER     = 'DUPLICATE_ORDER',

    /** Invalid Investor Id */
    INVALID_INVESTOR_ID = 'INVALID_INVESTOR_ID'
}

export const ORDER_REJECT_REASON_NAMING: Record<OrderRejectionReason, string> = {
    [OrderRejectionReason.BROKER_OPTION]:       'enums.order-reject-reason.broker_option',
    [OrderRejectionReason.UNKNOWN_SYMBOL]:      'enums.order-reject-reason.unknown_symbol',
    [OrderRejectionReason.EXCHANGE_CLOSED]:     'enums.order-reject-reason.exchange_closed',
    [OrderRejectionReason.EXCEEDS_LIMIT]:       'enums.order-reject-reason.exceeds_limit',
    [OrderRejectionReason.TOO_LATE]:            'enums.order-reject-reason.too_late',
    [OrderRejectionReason.UNKNOWN_ORDER]:       'enums.order-reject-reason.unknown_order',
    [OrderRejectionReason.DUPLICATE_ORDER]:     'enums.order-reject-reason.duplicate_order',
    [OrderRejectionReason.INVALID_INVESTOR_ID]: 'enums.order-reject-reason.invalid_investor_id'
};
